import { useMemo } from "react";
import { usePlatformConstantsQuery } from "@/lib/platformConstants/usePlatformConstantsQuery";
import {
  DEFAULT_DOMAIN_OPTIONS,
  type DomainKey,
  type DomainOption,
  type DomainOptionsDto,
} from "./defaults";
import { getDomainOptions, getOptionLabel, mergeDomainOptions } from "./helpers";

export function useDomainOptions() {
  const { data } = usePlatformConstantsQuery();
  const options = useMemo(
    () => mergeDomainOptions(data ?? null),
    [data],
  );

  return {
    options,
    getOptions: (domain: DomainKey, set: string): readonly DomainOption[] =>
      getDomainOptions(options, domain, set),
    getLabel: (
      domain: DomainKey,
      set: string,
      value: string | null | undefined,
    ): string => getOptionLabel(options, domain, set, value),
  };
}

/** Static accessors using offline defaults (module init / non-React). */
export const domainOptions = {
  defaults: DEFAULT_DOMAIN_OPTIONS,
  getOptions: (domain: DomainKey, set: string) =>
    getDomainOptions(DEFAULT_DOMAIN_OPTIONS, domain, set),
  getLabel: (domain: DomainKey, set: string, value: string | null | undefined) =>
    getOptionLabel(DEFAULT_DOMAIN_OPTIONS, domain, set, value),
};

export type { DomainKey, DomainOption, DomainOptionsDto };
